module.exports = __webpack_public_path__ + "img/doublecoins.144dc381.png";